"use strict";

angular.module("core")
.component("deliveryDateFilter", {
    bindings: {
        filterTitle: "<",
        filterField: "@",
    },
    templateUrl: require("./delivery-date-filter.component.html"),
    controllerAs: "deliveryDateFilterCtrl",
    controller: function($scope) {
        var _this = this;

        this.setToday = function() {
            var todayDate = moment().startOf('day');
            var filterValues = {};
            filterValues[_this.filterField + "_start"] = todayDate;
            filterValues[_this.filterField + "_end"] = todayDate;
            $scope.$broadcast("setDateFilter", _this.filterField, filterValues);
        };

        this.setTomorrow = function() {
            var tomorrowDate = moment().startOf('day').add(1, "days");
            var filterValues = {};
            filterValues[_this.filterField + "_start"] = tomorrowDate;
            filterValues[_this.filterField + "_end"] = tomorrowDate;
            $scope.$broadcast("setDateFilter", _this.filterField, filterValues);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/delivery-date-filter/delivery-date-filter.component.js
// module id = 861
// module chunks = 0